module.exports = __webpack_public_path__ + "static/media/SimpleLineIcons.d2285965.ttf";